

    import Vue from "vue";
    import {mapState} from "vuex";
    import {Ripple} from "vuetify/lib/directives/";
    // Components
    import RomaModalTop from "./RomaModalTop.vue";
    // Store
    import UnitPlan from "../../store/units/UnitPlan";
    import UnitPlanComments from "../../store/units/UnitPlanComments";
    // Interface
    import {IUnitPlanComments} from "../../interfaces/units/IUnitPlanComments";

    export default Vue.extend({
        name: "RomaMessageModal",
        props: {
            value: Boolean,
            parcialRequest: {
                type: Object,
                required: false
            },
            unit: {
                type: Object,
                required: false
            },
            title: {
                type: String,
                default: "Comentarios"
            },
            maxWidth: {
                type: String,
                default: "50%"
            },
            overlayOpacity: {
                type: String,
                default: "0.8"
            },
            persistent: {
                type: Boolean,
                default: true
            },
            filterBy: {
                type: Object,
                required: true
            },
            placeholder: {
                type: String,
                default: "Agrega un comentario..."
            }
        },
        data() {
            return {
                showComments: false,
                valid: false,
                loading: false,
                showing: this.value,
                message: "",
            };
        },
        created() {

        },
        computed: {
            ...mapState(["user"]),
            comments(): Array<IUnitPlanComments> {
                return UnitPlanComments.query()
                    .where(this.filterBy.field, this.filterBy.value)
                    .orderBy("fecha", "desc")
                    .orderBy("id", "desc")
                    .get();
            }
        },
        methods: {
            show(value: Boolean) {
                if (this.$refs.romaComment) this.$refs.romaComment.reset();
                this.showComments = false;
                this.message = null;
                this.$emit("input", value);
            },
            async comment() {
                this.loading = true;

                let msj = {
                    show: true,
                    color: "success",
                    text: "Se ha guardado el comentario!"
                };

                const request = Object.assign(
                    {},
                    {
                        descripcion: this.message
                    },
                    this.parcialRequest
                );

                const response = await this.$store.dispatch("saveComment", request);

                if (response.data && response.data.status && response.data.status.code === 1) {
                    //this.unit.comments_count++;
                    UnitPlan.update({ data: this.unit });
                    UnitPlanComments.insertOrUpdate({ data: response.data.content });
                    this.message = null;
                    this.$refs.romaComment.reset();
                    this.show(false);
                } else if (response.data && response.data.status && response.data.status.code === 3) {
                    msj.text = response.data.content.message;
                    msj.color = "red";

                } else {
                    msj.text = "No se pudo guardar el comentario";
                    msj.color = "red";

                }

                this.$store.state.snackbar = msj;
                this.loading = false;
            }
        },
        components: {
            RomaModalTop,
        },
        directives: {
            Ripple
        }
    });
